import { FC } from 'react';
import { ConclusionProps } from './Conclusion.types';
import {
  EmptyConclusionCardContent,
  EmptyConclusionContainer,
  EmptyConclusionText,
  EmptyConclusionIcon
} from './Conclusion.styles';
import { AllieCard, AllieText } from '../../../../../components';
import { AllieAlertCircleOutlineIcon } from '../../../../../styling/icons';

export const EmptyConclusion: FC<Pick<ConclusionProps, 'labels' | 'name' | 'date'>> = ({
  labels,
  name,
  date,
}) => {
  const message = labels.emptyConclusion.replace('{name}', name).replace('{date}', date);

  return (
    <EmptyConclusionContainer>
      <AllieText type="body2" color="neutral-90" weight={600}>
        {labels.conclusionTitle}
      </AllieText>
      <AllieCard
        radius="md"
        content={{
          children: (
            <EmptyConclusionCardContent>
              <EmptyConclusionIcon>
                <AllieAlertCircleOutlineIcon />
              </EmptyConclusionIcon>
              <EmptyConclusionText>
                <AllieText type="body2" color="neutral-60" weight={600}>
                  {labels.emptyTitle}
                </AllieText>
                <AllieText type="body2" color="neutral-70" weight={500}>
                  {message}
                </AllieText>
              </EmptyConclusionText>
            </EmptyConclusionCardContent>
          ),
        }}
      />
    </EmptyConclusionContainer>
  );
};
